import { parseISO, startOfDay, endOfDay, differenceInCalendarDays } from 'date-fns';

export const countInclusiveDays = (startISO: string, endISO: string): number => {
    const start = startOfDay(parseISO(startISO));
    const end = endOfDay(parseISO(endISO));
    return Math.max(1, differenceInCalendarDays(end, start) + 1);
};
